import React from 'react';
import { Typography, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigateWithScrollMemory } from '../../hooks/useNavigateWithScrollMemory';
import explicitIcon from '../../assets/explicit_icon.svg';

const AlbumTitleLink = ({
  title,
  to,
  state,
  contentRating,
  sx,
  iconSx,
  lineClamp = 2,
  inline = false,
  reserveExplicit = false,
  onClick,
}) => {
  const navigateWithScrollMemory = useNavigateWithScrollMemory();

  const handleClick = (e) => {
    // to prop이 있을 때만 네비게이션 로직 실행
    if (to) {
      onClick?.();
      if (!e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        navigateWithScrollMemory(to, { state });
      }
    }
  };

  // 타이틀과 아이콘을 포함하는 기본 UI 구조
  const content = (
    <Typography
      component={inline ? 'span' : 'p'}
      sx={{
        cursor: to ? 'pointer' : 'default',
        minWidth: 0,
        fontWeight: 700,
        ...(inline
          ? { display: 'inline', fontSize: 'inherit', color: 'inherit' }
          : {
              display: '-webkit-box',
              WebkitLineClamp: lineClamp,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              wordBreak: 'break-word',
              lineHeight: '1.5',
            }),
        ...sx,
        ...(reserveExplicit && { display: 'flex', alignItems: 'center', gap: '4px' }),
      }}
      title={title}
    >
      {reserveExplicit ? (
        <span
          style={{
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </span>
      ) : (
        title
      )}
      {contentRating === 'EXPLICIT' && (
        <Box
          component="img"
          src={explicitIcon}
          alt="Explicit"
          sx={{
            width: '0.714285em',
            height: '0.714285em',
            marginLeft: '4px',
            verticalAlign: 0,
            flexShrink: 0,
            ...iconSx,
            ...(reserveExplicit && { width: '0.714285em', height: '0.714285em', marginLeft: 0 }),
          }}
        />
      )}
    </Typography>
  );

  // to prop이 있으면 RouterLink로 감싸고, 없으면 그냥 content만 렌더링
  return to ? (
    <RouterLink
      to={to}
      state={state}
      onClick={handleClick}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      {content}
    </RouterLink>
  ) : (
    content
  );
};

export default AlbumTitleLink;
